// ─── Hook ─────────────────────────────────────────────────────────────────────

import { useGetApiV1ExamCorrectionGrid } from '@/shared/api/generated';

/**
 * Hook para carregar a grade de correção de questões de um exame.
 *
 * @param examPublishId - ID do exame publicado
 * @param page - Página atual (1-indexed)
 * @returns Questões do exame com estado de loading/error
 *
 * @example
 * ```tsx
 * const { items, totalPages, isLoading } = useExamCorrectionGrid(examPublishId, page);
 * ```
 */
export function useExamCorrectionGrid(examPublishId: number, page: number) {
  const query = useGetApiV1ExamCorrectionGrid({ examPublishId, pageNumber: page });

  return {
    items: query.data?.data ?? [],
    currentPage: query.data?.currentPage ?? 1,
    totalPages: query.data?.totalPages ?? 1,
    totalCount: query.data?.totalCount ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
